import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import { History } from 'history';
import { translatorStringsReducer } from './translator-strings';
import { customerPreferenceReducer } from './customer-preference';
import { variationsReducer } from './variations';
import { offersReducer } from './offers';
import { merchantsReducer } from './merchants';
import { deliveryPromiseReducer } from './delivery-promise';
import { waitlistSubscriptionReducer } from './waitlist-subscription';

export const createRootReducer = (history: History) =>
    combineReducers({
        router: connectRouter(history),
        translatorStringsState: translatorStringsReducer,
        customerPreferenceState: customerPreferenceReducer,
        variationsState: variationsReducer,
        offersState: offersReducer,
        merchantsState: merchantsReducer,
        deliveryPromiseState: deliveryPromiseReducer,
        waitlistSubscriptionState: waitlistSubscriptionReducer
    });

export default createRootReducer;